import { BaseEnvContribution, rafBasedSto } from "@visactor/vrender-core";

export class NodeEnvContribution extends BaseEnvContribution {
    constructor() {
        super(...arguments), this.type = "node", this._lastTime = 0, this.supportEvent = !1;
    }
    configure(service, pkg) {
        service.env === this.type && (service.setActiveEnvContribution(this), this.pkg = pkg);
    }
    getNodePackage(feature, requiredKey) {
        if (!this.pkg || requiredKey && "function" != typeof this.pkg[requiredKey]) throw new Error(`Node env requires node-canvas package before ${feature}. Use vglobal.setEnv('node', CanvasPkg) before createNodeVRenderApp(), or createNodeVRenderApp({ envParams: CanvasPkg }).`);
        return this.pkg;
    }
    getDynamicCanvasCount() {
        return 0;
    }
    getStaticCanvasCount() {
        return 999;
    }
    loadJson(url) {
        const jsonPromise = fetch(url).then((data => data.json()));
        return jsonPromise.then((json => ({
            data: json,
            state: "success"
        }))).catch((() => ({
            data: null,
            state: "fail"
        }))), jsonPromise;
    }
    loadArrayBuffer(url) {
        return fetch(url).then((data => data.arrayBuffer())).then((arrayBuffer => ({
            data: arrayBuffer,
            loadState: "success"
        }))).catch((() => ({
            data: null,
            loadState: "fail"
        })));
    }
    loadImage(url) {
        const {loadImage: loadImage} = this.getNodePackage("loadImage", "loadImage");
        return loadImage ? loadImage(url).then((image => ({
            loadState: image ? "success" : "fail",
            data: image
        }))).catch((() => ({
            loadState: "fail",
            data: null
        }))) : Promise.reject(new Error("node-canvas loadImage could not be found!"));
    }
    loadSvg(svgStr) {
        const Resvg = this.getNodePackage("loadSvg").Resvg;
        if (!Resvg) return Promise.reject(new Error("@resvg/resvg-js svgParser could not be found!"));
        const pngData = new Resvg(svgStr).render().asPng();
        return this.loadImage(pngData);
    }
    createCanvas(params) {
        const {createCanvas: createCanvas} = this.getNodePackage("createCanvas", "createCanvas");
        return createCanvas(params.width, params.height);
    }
    releaseCanvas(canvas) {}
    getDevicePixelRatio() {
        return 1;
    }
    getRequestAnimationFrame() {
        return function(callback) {
            return rafBasedSto.call(callback);
        };
    }
    getCancelAnimationFrame() {
        return h => {
            rafBasedSto.clear(h);
        };
    }
    addEventListener(type, listener, options) {}
    removeEventListener(type, listener, options) {}
    getElementById(str) {
        return null;
    }
    getRootElement() {
        return null;
    }
    dispatchEvent(event) {}
    release(...params) {}
    createOffscreenCanvas(params) {}
}
//# sourceMappingURL=node-contribution.js.map
